import axios, { AxiosInstance } from 'axios';

class ReportsApiService {
  private axiosInstance: AxiosInstance;

  constructor() {
    const adminKey = process.env.VUE_APP_REPORTS_ADMIN_KEY;
    if (!adminKey) {
      console.error('[ReportsApiService] VUE_APP_REPORTS_ADMIN_KEY is not set — all requests will fail with 401');
    }

    this.axiosInstance = axios.create({
      baseURL: process.env.VUE_APP_REPORTS_API_URL,
      timeout: 15000,
      headers: {
        'Content-Type': 'application/json',
        'x-admin-key': adminKey ?? '',
      },
    });

    this.axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error?.response?.status;
        const url = error?.config?.url;
        console.error(`[ReportsApiService] HTTP ${status ?? 'network'} error on ${url}`, error);
        return Promise.reject(error);
      },
    );
  }

  get<T = any>(url: string, params: Record<string, any> = {}) {
    return this.axiosInstance.get<T>(url, { params });
  }
}

export default new ReportsApiService();
